import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import SecureLS from "secure-ls";
import Swal from "sweetalert2";
import ReceiptHero from "./ReceiptHero";

const ls = new SecureLS({ encodingType: "aes" });

const ReceiptServiceCharge = () => {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    const fetchServiceCharge = async () => {
      try {
        const token = ls.get("authToken");
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/v1/api/pos/service-charge`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setValue(res.data.serviceCharge.toString());
      } catch (err) {
        console.error("Error fetching service charge:", err);
      }
    };

    fetchServiceCharge();
  }, []);

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (/^\d*$/.test(newValue)) {
      setValue(newValue);
      const parsed = parseInt(newValue, 10);
      setIsValid(parsed >= 1 && parsed <= 100);
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const token = ls.get("authToken");
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api/pos/update-service-charge`,
        { value: parseInt(value, 10) },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      Swal.fire("Success", "Service charge updated.", "success");
    } catch (err) {
      Swal.fire("Error", "Failed to update service charge.", "error");
      console.error("Error saving:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ padding: 3 }}>
      <ReceiptHero />

      <Box
        sx={{
          mt: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography gutterBottom>Service Charge (%)</Typography>
        <TextField
          type="text"
          value={value}
          onChange={handleChange}
          error={!isValid}
          helperText={!isValid ? "Value: 1-100" : "Value: 1-100"}
          inputProps={{ min: 1, max: 100}}
          sx={{ width: 200 }}
        />

        <Button
          variant="contained"
          sx={{ mt: 3, minWidth: 100 }}
          onClick={handleSave}
          disabled={loading || !isValid}
        >
          {loading ? (
            <CircularProgress size={24} sx={{ color: "#fff" }} />
          ) : (
            "Save"
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default ReceiptServiceCharge;
